import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges
} from '@angular/core';

const PROGRESS_MESSAGES = {
  import: {
    success: 'Import successful',
    failed: 'Import failed',
    warning: 'Imported with errors'
  }
};

const PROGRESS_ICON = {
  success: 'fa-check-circle',
  failed: 'fa-exclamation-circle',
  warning: 'fa-exclamation-triangle'
};

@Component({
  selector: 'ls-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent implements OnChanges {
  @Input()
  status: 'pending' | 'success' | 'failed' | 'warning' = 'pending';

  @Input()
  type: 'import' | 'export' = 'import';

  progressMessage = '';
  progressIcon = '';

  ngOnChanges() {
    this.progressMessage =
      this.status !== 'pending'
        ? PROGRESS_MESSAGES[this.type][this.status]
        : '';
    this.progressIcon = PROGRESS_ICON[this.status];
  }
}
